import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 lg:px-8 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Serene%20minimalist%20cozy%20reading%20nook%20with%20warm%20candlelight%2C%20plush%20textiles%20in%20cream%20and%20beige%20tones%2C%20gentle%20steam%20rising%20from%20a%20warm%20cup%20of%20tea%2C%20soft%20diffused%20lighting%20creating%20a%20peaceful%20evening%20atmosphere%2C%20minimalist%20Scandinavian%20interior%2C%20cozy%20hygge%20aesthetic%2C%20dreamy%20soft%20focus%20photography&width=1920&height=800&seq=cta-asmr-01&orientation=landscape"
        alt="开始您的放松之旅"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 text-center max-w-2xl mx-auto">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          准备好开始放松了吗？
        </h2>
        <p className="text-background-50/70 text-sm md:text-base mb-8 leading-relaxed">
          无需下载、无需注册，打开网页即可畅听海量ASMR音频。
          现在就开启您的听觉疗愈之旅吧！
        </p>
        <Link
          to="/category/zhumian"
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-full text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-headphone-line"></i>
          立即免费收听
        </Link>
      </div>
    </section>
  );
}